module.exports = __webpack_public_path__ + "img/welcome.5c8c85aa.png";